import { render, staticRenderFns } from "./SincronizacaoInicial.vue?vue&type=template&id=4a006d8e&scoped=true"
import script from "./SincronizacaoInicial.vue?vue&type=script&lang=js"
export * from "./SincronizacaoInicial.vue?vue&type=script&lang=js"
import style0 from "./SincronizacaoInicial.vue?vue&type=style&index=0&id=4a006d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a006d8e",
  null
  
)

export default component.exports